var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { configure } from 'mobx';
import './index.css';
import WizardContainer from './modules/applicaction/components/wizard-container';
import ApplicationFormStore from './modules/applicaction/stores/application-form-store';
import { DocumentListing } from './modules/document-management/my-account-documents/components/documents-listing';
import { closeSnackbar, SnackbarProvider } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SignupPage } from "./modules/signup/signup-page";
configure({
    enforceActions: "always",
});
var wnd = window;
wnd.renderApplicationForm = function (id) {
    var container = document.getElementById(id);
    if (container) {
        var root = createRoot(container);
        var store = new ApplicationFormStore();
        root.render(_jsx(React.Fragment, { children: _jsx(WizardContainer, { applicationFormStore: store }) }));
    }
};
wnd.renderSignupForm = function (id, captcha, countries) {
    var container = document.getElementById(id);
    if (container) {
        var root = createRoot(container);
        root.render(_jsx(React.Fragment, { children: _jsx(SnackbarProvider, __assign({ autoHideDuration: null, maxSnack: 3, action: function (snackbarId) { return (_jsx(IconButton, __assign({ onClick: function () { return closeSnackbar(snackbarId); } }, { children: _jsx(CloseIcon, {}) }))); } }, { children: _jsx(SignupPage, { countries: countries, captcha: captcha }) })) }));
    }
};
wnd.renderDocuments = function (id, leadId) {
    var container = document.getElementById(id);
    if (container) {
        var root = createRoot(container);
        root.render(_jsx(React.Fragment, { children: _jsx(SnackbarProvider, __assign({ maxSnack: 3, action: function (snackbarId) { return (_jsx(IconButton, __assign({ onClick: function () { return closeSnackbar(snackbarId); } }, { children: _jsx(CloseIcon, {}) }))); } }, { children: _jsx(DocumentListing, { leadId: leadId }) })) }));
    }
};
